import { YandexCaptchaStatus } from 'types/captcha';
import { ErrorType } from '../errors';

export const YandexCaptchaError = {
  NETWORK_ERROR: 'network-error',
  JAVASCRIPT_ERROR: 'javascript-error',
  VALIDATION_ERROR: ErrorType.CAPTCHA_FINAL_ERROR,
};

export const Y_CAPTCHA_PARAM_KEY = 'y_captcha_response';

export const YandexCaptchaErrors = Object.values(YandexCaptchaStatus);
